import type {
  GetBaseloadAndCO2ChartMarketMonitoringParams,
  GetBaseloadAndCO2ChartMarketMonitoringResponse,
  GetBrentAndCoalChartMarketMonitoringParams,
  GetBrentAndCoalChartMarketMonitoringResponse,
  GetCO2ForNext4YearsMarketMonitoringParams,
  GetCO2ForNext4YearsMarketMonitoringResponse,
  GetCO2SpotChartMarketMonitoringParams,
  GetCO2SpotChartMarketMonitoringResponse,
  GetOtherMarketMonitoringIndicatorsParams,
  GetOtherMarketMonitoringIndicatorsResponse,
  GetProductsPriceVariationMarketMonitoringResponse,
  GetSparkSpreadMarketMonitoringParams,
  GetSparkSpreadMarketMonitoringResponse,
} from "$/lib/types/api/market-monitoring/other-markets.type";
import { restApiClient } from "../restApiClient";

export const getOtherMarketsIndicators = async (
  params: GetOtherMarketMonitoringIndicatorsParams,
) => {
  return restApiClient
    .url("/market-monitoring/other-markets/indicators")
    .query({ ...params })
    .get<GetOtherMarketMonitoringIndicatorsResponse>();
};

export const getCleanSparkSpreadCal1 = async (
  params: GetSparkSpreadMarketMonitoringParams,
) => {
  return restApiClient
    .url("/market-monitoring/other-markets/spark-spread-future")
    .query({ ...params })
    .get<GetSparkSpreadMarketMonitoringResponse>();
};

export const getCleanSparkSpreadSpot = async (
  params: GetSparkSpreadMarketMonitoringParams,
) => {
  return restApiClient
    .url("/market-monitoring/other-markets/spark-spread-spot")
    .query({ ...params })
    .get<GetSparkSpreadMarketMonitoringResponse>();
};

export const getBaseloadAndCO2Chart = async (
  params: GetBaseloadAndCO2ChartMarketMonitoringParams,
) => {
  return restApiClient
    .url("/market-monitoring/other-markets/baseload-co2-chart")
    .query({ ...params })
    .get<GetBaseloadAndCO2ChartMarketMonitoringResponse>();
};

export const getBrentAndCoalChart = async (
  params: GetBrentAndCoalChartMarketMonitoringParams,
) => {
  return restApiClient
    .url("/market-monitoring/other-markets/brent-coal-chart")
    .query({ ...params })
    .get<GetBrentAndCoalChartMarketMonitoringResponse>();
};

export const getCO2ForNext4Years = async (
  params: GetCO2ForNext4YearsMarketMonitoringParams,
) => {
  return restApiClient
    .url("/market-monitoring/other-markets/co2-chart")
    .query({ ...params })
    .get<GetCO2ForNext4YearsMarketMonitoringResponse>();
};

export const getCO2SpotChart = async (
  params: GetCO2SpotChartMarketMonitoringParams,
) => {
  return restApiClient
    .url("/market-monitoring/other-markets/co2-spot-chart")
    .query({ ...params })
    .get<GetCO2SpotChartMarketMonitoringResponse>();
};

export const getPriceVariation = async (params: { year: string }) => {
  return restApiClient
    .url("/market-monitoring/other-markets/products-price-variation")
    .query({ ...params })
    .get<GetProductsPriceVariationMarketMonitoringResponse>();
};
